import { useEffect, useState } from "react";
import api from "@/lib/api";
import { ArrowRightLeft, X } from "lucide-react";

// Small dismissible notice: the cashier's open shift started on another register. Their shift continues here;
// sales from now on are attributed to THIS register. Remembered per shift+register for the browser session.
export function RegisterSwitchNotice({ state }) {
  const [shift, setShift] = useState(null);
  const [hidden, setHidden] = useState(false);
  const reg = state?.status === "ok" ? state.register : null;
  useEffect(() => {
    if (!reg) return;
    api.get("/shifts/current").then((r) => setShift(r.data)).catch(() => setShift(null));
  }, [reg?.id]); // eslint-disable-line react-hooks/exhaustive-deps
  if (!reg || !shift || shift.status !== "open" || !shift.register_id || shift.register_id === reg.id) return null;
  const key = `neec_reg_switch_${shift.id}_${reg.id}`;
  if (hidden || sessionStorage.getItem(key)) return null;
  const from = shift.opened_on_register || (shift.by_register || []).find((b) => b.register_id === shift.register_id)?.register_name || shift.register || "another register";
  return (
    <div className="fixed top-20 left-1/2 -translate-x-1/2 z-30 max-w-[calc(100vw-2rem)] rounded-xl border border-sky-500/40 bg-sky-500/10 backdrop-blur px-4 py-2.5 text-sm shadow-lg flex items-start gap-2" data-testid="register-switch-notice">
      <ArrowRightLeft className="w-4 h-4 text-sky-600 mt-0.5 shrink-0" />
      <div>
        <p className="font-semibold">You're now on {reg.display_name}. Your shift continues.</p>
        <p className="text-xs text-muted-foreground">Shift opened on {from}. Sales from here are recorded on {reg.display_name}; your shift totals still count everything you sell.</p>
      </div>
      <button type="button" className="ml-1 rounded p-0.5 hover:bg-secondary" onClick={() => { sessionStorage.setItem(key, "1"); setHidden(true); }} aria-label="Dismiss" data-testid="register-switch-dismiss"><X className="w-4 h-4" /></button>
    </div>
  );
}
